/**
 * Redux slice for sharing enriched media-page content across all consumers.
 *
 * The MediaPageView (content-type view) owns the content freshness engine and
 * dispatches enriched content here. Consumers (VideoJS block, Downloads block,
 * SubtitleModal in the Toolbar portal) read from this slice via useSelector.
 *
 * Shape:
 *   content    — the full page object with enriched items[].output_state etc.
 *   isPolling  — whether the freshness engine is actively polling
 */

export const SET_MEDIA_PAGE_ENRICHED = 'SET_MEDIA_PAGE_ENRICHED';
export const SET_MEDIA_PAGE_POLLING = 'SET_MEDIA_PAGE_POLLING';
export const CLEAR_MEDIA_PAGE_ENRICHED = 'CLEAR_MEDIA_PAGE_ENRICHED';

export const setMediaPageEnriched = (content) => ({
  type: SET_MEDIA_PAGE_ENRICHED,
  content,
});

export const setMediaPagePolling = (isPolling) => ({
  type: SET_MEDIA_PAGE_POLLING,
  isPolling,
});

export const clearMediaPageEnriched = () => ({
  type: CLEAR_MEDIA_PAGE_ENRICHED,
});

const initialState = { content: null, isPolling: false };

export default function mediaPageEnriched(state = initialState, action = {}) {
  switch (action.type) {
    case SET_MEDIA_PAGE_ENRICHED:
      return { ...state, content: action.content };
    case SET_MEDIA_PAGE_POLLING:
      return { ...state, isPolling: action.isPolling };
    case CLEAR_MEDIA_PAGE_ENRICHED:
      return initialState;
    default:
      return state;
  }
}
